import { Component, Input, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { AdviserModel }    from './typings/adviser';
import { AdvisersService } from './advisers.service';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector   : 'wor-adviser',
  template: require('./adviser.component.html')
})
export class AdviserComponent implements OnInit {
  @BlockUI('serviceAdviserBlock') block : NgBlockUI;

  @Input() adviser: AdviserModel;

  originalCode : string;

  constructor (
    private advisersService : AdvisersService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  delete () : void {
    this.advisersService.delete(this.adviser)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SERVICE_ADVISER_DELETED'), 'success');

      this.router.stateService.go('app.advisers');
    })
    .catch(error => this.messagesService.error(error));
  }

  ngOnInit () : void {
    if ( this.adviser.adviser_code ) {
      this.originalCode = this.adviser.adviser_code;
    }
  }

  save ( form : NgForm ) : void {
    this.block.start();

    this.adviser.adviser_code = this.adviser.adviser_code.toUpperCase();

    Promise.resolve()
    .then(() => this.adviser.id
      ? this.advisersService.update(this.adviser)
      : this.advisersService.create(this.adviser))
    .then(( adviser : AdviserModel ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.ADVISER_SAVED'), 'success');

      this.router.stateService.go('app.adviser', {
        id: adviser.id
      }, {
        reload: true
      });
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }

  validateCode ( code : string ) : ng.IPromise<boolean> {
    this.block.start();

    return this.advisersService.validateCode(code, this.originalCode)
      .finally(() => this.block.stop());
  }
}
